/**************************************************
 * Nombre:       Tarjeta_Contacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Contacto = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 2, sm: 2, md: 1}} sx={{justifyContent: 'flex-start'}}>
                <item.icono sx={{width: 32, height: 32}}/>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 11}} sx={{justifyContent: 'flex-start', ml: !masSM ? -1 : 0}}>
                <Typography sx={{fontSize: 18, fontWeight: 600, fontFamily: 'Roboto'}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 12}}
                  sx={{justifyContent: 'flex-start', ml: !masSM ? -1 : 0, pl: sCell ? 1 : 0}}>
                <Typography sx={{fontSize: 18, fontWeight: 300, fontFamily: 'Roboto'}}>
                    {item.descripcion}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Contacto